/* eslint-disable */
var config = require('./.config');

function getConfig() {
    return config;
}

export default getConfig;